import { graphqlRequest } from "../../services/apiService";

export const fetchAllCompanyList = async () => {
  try {
    const query = `
      query GetClientList {
        getClientList {
          id
          company
          city
          zipCode
          address
          state
          industry
          weeklyHours
          clientName
          clientType
          streetAddress
        }
      }
    `;

    const data = await graphqlRequest(query, {});
    return data.getClientList;
  } catch (error) {
    console.error("Fetch error:", error);
    throw new Error(error.message || "Network error");
  }
};